/* 原本 vasallo-jp.com/top/js/top.js から自家ホスト化。
   getNews()（WordPress廃止でCORS失敗）を削除し、
   Liquid出力済みNEWSのスライダー初期化に置換（2026-08-28）。 */
$(function(){

    var canvasWidth;
    var canvasHeight;
    var spFlag = false;
    var loadImageFlag = false;
    var viewGnav = false;

    function onResize() {
        canvasWidth = window.innerWidth ? window.innerWidth: $(window).width();
        canvasHeight = window.innerHeight ? window.innerHeight: $(window).height();
        if (canvasWidth <= 768) {
            if(!spFlag) {
                //console.log("spImage -> SP");
                $('.-spImage').setSpImages(spFlag);
                $('.-retina').removeRetinaImagesStyle();
            }
            spFlag = true;
        } else {
            if(spFlag) {
                $('.-spImage').setSpImages(spFlag);
                loadImageFlag = $('.-retina').retinaImages();
                //console.log("spImage -> PC");
            }

            if (!loadImageFlag) {
                loadImageFlag = $('.-retina').retinaImages();
            }

            spFlag = false;
        }
    }

    $(window).scroll(function(){
        if(viewGnav === false) {
            if($(window).scrollTop() >= 800) {
                viewGnav = true;
                $('header').not(":animated").css({top:'-100px', position:'fixed'}).animate({'top':'0'}, 800);
            }
        }
        else {
            if($(window).scrollTop() <= 700) {
                viewGnav = false;
                $('header').not(":animated").animate({'top':'-100px'}, 300, function() {
                    $(this).css({top:'0', position:'absolute'});
                });

            }
        }
    });


    /////////////////////////////////////////////////////////////////////////////////////////


    /////////////////////////////////////////////////////////////////////////////////////////


    function setup() {
        // NEWS は Liquid で静的に出力済み。取得を待たずスライダーだけ張る。
        var $newsUl = $('.news__read--wrap ul');
        if ($newsUl.length && $newsUl.children('li').length && !$newsUl.closest('.bx-viewport').length) {
            $newsUl.bxSlider({ auto: true, pager: false, controls: true, touchEnabled: false });
        }
        $('a[href^="#"]').SmoothScroll();
        $('.main__mainVisual ul').bxSlider({
            controls: false,
            auto: true
        });
    }

    // スマホ用メニュー表示
    $("a.spMenu__open").on('click', function(e) {
        e.preventDefault();
        $(".spMenu__area--sp").show();

    });
    $('a.spMenu__close').on('click', function(e) {
        e.preventDefault();
        $('.spMenu__area--sp').hide();
    });


    /////////////////////////////////////////////////////////////////////////////////////////


    $(window).resize(function() {
        onResize();
    });

    $(window).ready(function() {
        setup();
        onResize();
    });

    $(window).load(function() {
    });

});